// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1InvoiceCreateResponseSchema } from './v1/invoiceCreateResponseSchema';
import { v1InvoicesCreateSchema } from './v1/invoices/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createInvoicePathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const createInvoiceHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoices created
 */
export const createInvoice201Schema = z.lazy(() => v1InvoiceCreateResponseSchema);

/**
 * @description Unauthorized
 */
export const createInvoice401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Validation errors
 */
export const createInvoice422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createInvoiceMutationRequestSchema = z.lazy(() => v1InvoicesCreateSchema);

export const createInvoiceMutationResponseSchema = z.lazy(() => createInvoice201Schema);
